import { render, staticRenderFns } from "./WorkflowKanbanPage.vue?vue&type=template&id=59e6c2c8&scoped=true"
import script from "./WorkflowKanbanPage.vue?vue&type=script&lang=js"
export * from "./WorkflowKanbanPage.vue?vue&type=script&lang=js"
import style0 from "./WorkflowKanbanPage.vue?vue&type=style&index=0&id=59e6c2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e6c2c8",
  null
  
)

export default component.exports